import type { Seat } from '@ordago/rules';

// `gsap.core.Timeline` comes from GSAP's ambient global namespace, so no import
// is needed — and importing the value here would pull the whole library into a
// module that is otherwise pure arithmetic.

/**
 * Resolves when a timeline finishes.
 *
 * Deliberately does *not* resolve when the timeline is killed. A killed
 * timeline means the room was torn down, and at that point the director's
 * watchdog is the thing that unblocks the queue — one mechanism for "this
 * never finished", not two that can disagree.
 */
export function played(timeline: gsap.core.Timeline): Promise<void> {
  return new Promise<void>((resolve) => {
    timeline.eventCallback('onComplete', () => {
      resolve();
    });
  });
}

/**
 * The four seats starting at mano. Server seats are already anticlockwise
 * (backend.md §1.4), so counting up from mano *is* the dealing order — and,
 * because `screenSlot` preserves that rotation, it is also the order the cards
 * appear to travel in on screen.
 */
export function manoOrder(mano: Seat): Seat[] {
  return [0, 1, 2, 3].map((i) => ((mano + i) % 4) as Seat);
}

/** `DOMRect` is not structured-cloneable in every path; this shape always is. */
export interface Rect {
  left: number;
  top: number;
  width: number;
  height: number;
}

export function toRect(r: DOMRect): Rect {
  return { left: r.left, top: r.top, width: r.width, height: r.height };
}

export function asDOMRect(r: Rect): DOMRect {
  return new DOMRect(r.left, r.top, r.width, r.height);
}
